import { useMutation, UseMutationResult } from "@tanstack/react-query";
import {
  leadListsApi,
  combineListOfLeadsApi,
} from "../../../libs/landvoice-api";
import { LeadList } from "../../../types/neighborhoodSearch";
import { NS_COMBINE_LIST_OF_LEADS_MUTATION_KEY } from "../constants/cacheKeys";

export const useCombineListOfLeadsMutation = (): UseMutationResult<
  LeadList,
  Error,
  { listIds: string[] }
> => {
  return useMutation<LeadList, Error, { listIds: string[] }>({
    mutationKey: [NS_COMBINE_LIST_OF_LEADS_MUTATION_KEY],
    mutationFn: async ({ listIds }: { listIds: string[] }) => {
      const newSearch = (
        await combineListOfLeadsApi.combineListOfLeads({
          list_ids: listIds,
        })
      )?.data;

      const fetchLeadListsPromises = listIds.map((id) =>
        leadListsApi.getListObj(id)
      );
      const leadListResponses = await Promise.all(fetchLeadListsPromises);

      const leadLists = leadListResponses.map(response => response.data as LeadList);

      if (!newSearch.id) {
        throw new Error("Failed to create combined search - no ID returned");
      }

      const updatedNewSearch = await leadListsApi.updateList(newSearch.id, {
        ...newSearch,
        search_parameters: {
          ...newSearch.search_parameters,
          combinedSearchSources: leadLists
            .filter((leadList) => leadList?.id && leadList?.name)
            .map((leadList) => ({
              searchId: leadList.id,
              searchName: leadList.name,
              searchRegion: leadList.search_parameters?.searchRegion,
              searchResultCount: leadList.result_count,
            })),
        },
      });

      return updatedNewSearch.data;
    },
  });
};